// extracted by mini-css-extract-plugin
export default {"square":"Square_square__G413z","blocked":"Square_blocked__HZwnN","inValidWord":"Square_inValidWord__CG6Vk"};